// Anatomia da tela Filas & Chatbot (/queues) — mockup "Tela Aeros Dark -
// Filas e Chatbot": faixa de KPIs, card de tabela em CSS grid com alça de
// arraste e a nota de reordenação no rodapé.
import { makeStyles, alpha } from "@material-ui/core/styles";
import { AEROS, stateText } from "../../styles/aerosTokens";

export const MONO = "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace";

// Colunas do mockup: alça, ID, nome, cor, ordem, saudação, chatbot, ações.
export const TABLE_GRID =
  "44px 56px minmax(0,1.3fr) 90px 110px minmax(0,2fr) 160px 96px";

const useQueuePageStyles = makeStyles((theme) => {
  const isLight = theme.palette.type === "light";
  const borderSoft = isLight ? theme.palette.divider : "rgba(255,255,255,0.06)";
  const borderCard = isLight ? theme.palette.divider : "rgba(255,255,255,0.07)";

  return {
    pageSubtitle: {
      fontSize: 12,
      color: theme.palette.text.secondary,
      lineHeight: 1.3,
      marginTop: 1,
    },

    // ---- KPIs ----
    kpiGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(4,minmax(0,1fr))",
      gap: 12,
      marginBottom: 16,
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "repeat(2,minmax(0,1fr))",
      },
    },
    kpiCard: {
      backgroundColor: theme.palette.aeros.surface,
      border: `1px solid ${borderCard}`,
      borderRadius: 12,
      padding: "14px 16px",
    },
    kpiLabel: {
      fontSize: 11,
      fontWeight: 600,
      color: theme.palette.text.secondary,
      textTransform: "uppercase",
      letterSpacing: "0.06em",
    },
    kpiValue: {
      fontSize: 22,
      fontWeight: 700,
      letterSpacing: "-0.02em",
      marginTop: 4,
      color: theme.palette.text.primary,
      fontVariantNumeric: "tabular-nums",
    },
    kpiHint: {
      fontSize: 11,
      color: theme.palette.aeros.textTertiary,
      marginTop: 2,
    },

    // ---- linha da tabela ----
    dragHandle: {
      color: theme.palette.aeros.textTertiary,
      cursor: "grab",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& .MuiSvgIcon-root": { fontSize: 18 },
      "&:active": { cursor: "grabbing" },
    },
    dragging: { opacity: 0.5 },
    dropTarget: {
      boxShadow: `inset 0 2px 0 0 ${theme.palette.primary.main}`,
    },
    idCell: {
      fontSize: 12.5,
      color: theme.palette.text.secondary,
      fontVariantNumeric: "tabular-nums",
    },
    nameCell: { display: "flex", alignItems: "center", gap: 10, minWidth: 0 },
    tile: {
      width: 34,
      height: 34,
      borderRadius: 10,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flex: "none",
      "& .MuiSvgIcon-root": { fontSize: 18 },
    },
    queueName: {
      fontSize: 13.5,
      fontWeight: 600,
      color: theme.palette.text.primary,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    queueSub: { fontSize: 11, color: theme.palette.text.secondary },
    colorCell: { display: "flex", alignItems: "center", gap: 6, minWidth: 0 },
    swatch: {
      width: 22,
      height: 22,
      borderRadius: 6,
      flex: "none",
      boxShadow: "0 0 0 2px rgba(255,255,255,0.08)",
    },
    colorHex: {
      fontFamily: MONO,
      fontSize: 10.5,
      color: theme.palette.text.secondary,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    orderBadge: {
      width: 26,
      height: 26,
      borderRadius: 8,
      backgroundColor: isLight ? theme.palette.aeros.surface2 : "#0E1119",
      border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.1)"}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 12,
      fontWeight: 700,
      fontVariantNumeric: "tabular-nums",
      color: theme.palette.text.primary,
    },
    greetingCell: {
      fontSize: 12.5,
      color: theme.palette.text.primary,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    greetingEmpty: { color: theme.palette.aeros.textTertiary, fontStyle: "italic" },
    botCell: { display: "flex", flexDirection: "column", gap: 4, minWidth: 0 },
    botPill: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      fontSize: 11,
      fontWeight: 600,
      borderRadius: 6,
      padding: "2px 8px",
      width: "fit-content",
      maxWidth: "100%",
      color: stateText(theme, "#C08BFF", "purple"),
      backgroundColor: alpha(theme.palette.primary.main, 0.14),
      "& .MuiSvgIcon-root": { fontSize: 13 },
    },
    botPillOff: {
      color: theme.palette.text.secondary,
      backgroundColor: isLight ? theme.palette.aeros.surface2 : "rgba(255,255,255,0.06)",
    },
    schedLine: {
      fontSize: 11,
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      color: theme.palette.text.secondary,
      "& .MuiSvgIcon-root": { fontSize: 13 },
    },
    schedAlways: { color: stateText(theme, AEROS.success, "success") },

    reorderHint: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      padding: "12px 18px",
      fontSize: 12,
      color: theme.palette.aeros.textTertiary,
      borderTop: `1px solid ${borderSoft}`,
      "& .MuiSvgIcon-root": { fontSize: 15 },
    },
  };
});

export default useQueuePageStyles;
